module.exports = __webpack_public_path__ + "img/17_90.c2282236.png";